import React, { Component } from 'react'
import { getReferences, getAttendanceModeCodesDetails, getAttendanceModeDescription } from '../../../services/vu'
import { CustomModal } from './Modal'
import { sortBy, uniqBy } from 'lodash'
import {
  getDropDateUnitTextAddEdit,
  unitDropDatePassed,
  unitDropDateNotPassed,
  unitHasDropDate
} from '../../../helpers/unitDropDateHelper'
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material'

class UnitModal extends Component {
  constructor(props) {
    super(props)

    let defaultAcademicYear = this.props.academicYear
    let studyPeriod = this.props.studyPeriod
    let availableUnitsLnA = this.getDefaultLocationsNAttendanceModes(
      defaultAcademicYear,
      studyPeriod
    )

    this.state = {
      ...this.getInitialModalState(
        defaultAcademicYear,
        studyPeriod,
        availableUnitsLnA
      ),
      locations: [],
      showDropDatePassedConfirmationModal: false,
      dropDateSubmissionConfirmation: false,
      attendanceModeList: []
    }
  }

  componentDidMount() {
    Promise.all([getReferences(), getAttendanceModeCodesDetails()]).then(([{ locationList = [] }, attendanceModeList]) => {
      this.setState({
        locations: locationList,
        attendanceModeList : attendanceModeList.referenceCodes
      })
    })
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      this.props.isOpen &&
      this.props.units !== prevProps.units &&
      this.props.units.length
    ) {
      let defaultAcademicYear = this.props.academicYear
        ? this.props.academicYear
        : this.state.academicYear
      let studyPeriod = this.props.studyPeriod
        ? this.props.studyPeriod
        : this.state.studyPeriod
      let availableUnitsLnA = this.getDefaultLocationsNAttendanceModes(
        defaultAcademicYear,
        studyPeriod
      )
      this.setState(
        this.getInitialModalState(
          defaultAcademicYear,
          studyPeriod,
          availableUnitsLnA
        )
      )
    }

    if (
      prevState.modalAcademicYear !== this.state.modalAcademicYear ||
      prevState.modelLocation !== this.state.modelLocation ||
      prevState.modelAttendanceMode !== this.state.modelAttendanceMode ||
      prevProps.units !== this.props.units
    ) {
      const options = this.getCalendarTypeOptions();
      if (options.length === 1 && !options[0].disabled && this.state.modalStudyPeriodNKeyNumber !== options[0].value) {
        this.setState({
          modalStudyPeriodNKeyNumber: options[0].value,
          modelStudyPeriod: options[0].unitData.unitAvailabilityStudyPeriodCode,
          modelKeyNumber: options[0].unitData.unitAvailabilityKeyNumber
        });
      }
    }
  }

  getInitialModalState = (
    defaultAcademicYear,
    studyPeriod,
    availableUnitsLnA
  ) => ({
    modalAcademicYear: defaultAcademicYear,
    modalLocationNAttendanceModes: availableUnitsLnA,
    modalLocationNAttendanceMode: this.getDefaultUnitInformation(
      availableUnitsLnA,
      defaultAcademicYear,
      studyPeriod,
      'modalLocationNAttendanceMode'
    ),
    modelLocation: this.getDefaultUnitInformation(
      availableUnitsLnA,
      defaultAcademicYear,
      studyPeriod,
      'modelLocation'
    ),
    modelAttendanceMode: this.getDefaultUnitInformation(
      availableUnitsLnA,
      defaultAcademicYear,
      studyPeriod,
      'modelAttendanceMode'
    ),
    modalStudyPeriodNKeyNumber: this.getDefaultUnitInformation(
      availableUnitsLnA,
      defaultAcademicYear,
      studyPeriod,
      'modalStudyPeriodNKeyNumber',
      true
    ),
    modelStudyPeriod: this.getDefaultUnitInformation(
      availableUnitsLnA,
      defaultAcademicYear,
      studyPeriod,
      'modelStudyPeriod',
      true
    ),
    modelKeyNumber: this.getDefaultUnitInformation(
      availableUnitsLnA,
      defaultAcademicYear,
      studyPeriod,
      'modelKeyNumber',
      true
    )
  })

  getDefaultUnitInformation = (
    availableUnitsLnA,
    defaultAcademicYear,
    studyPeriod,
    actualKey,
    includeLocationFiltering = false
  ) => {
    if (defaultAcademicYear !== '' && availableUnitsLnA.length === 1) {
      let unitSelection = availableUnitsLnA[0]

      let unitFiltered = this.props.units.filter(
        unit => unit.unitAvailabilityYear === defaultAcademicYear
      )

      if (studyPeriod) {
        unitFiltered = unitFiltered.filter(
          unit => unit.unitAvailabilityStudyPeriodCode === studyPeriod
        )
      }

      if (includeLocationFiltering) {
        unitFiltered = unitFiltered
          .filter(
            unit =>
              unit.unitAvailabilityLocationCode ===
              unitSelection.unitAvailabilityLocationCode
          )
          .filter(
            unit =>
              unit.unitAvailabilityAttendanceModeCode ===
              unitSelection.unitAvailabilityAttendanceModeCode
          )
      }

      if (unitFiltered.length === 1) {
        if (actualKey === 'modelKeyNumber') {
          return unitFiltered[0].unitAvailabilityKeyNumber
        } else if (actualKey === 'modelStudyPeriod') {
          return unitFiltered[0].unitAvailabilityStudyPeriodCode
        } else if (actualKey === 'modalStudyPeriodNKeyNumber') {
          return (
            unitFiltered[0].unitAvailabilityKeyNumber +
            '-' +
            unitFiltered[0].unitAvailabilityStudyPeriodCode
          )
        } else if (actualKey === 'modelAttendanceMode') {
          return unitFiltered[0].unitAvailabilityAttendanceModeCode
        } else if (actualKey === 'modelLocation') {
          return unitFiltered[0].unitAvailabilityLocationCode
        } else if (actualKey === 'modalLocationNAttendanceMode') {
          return this.getLocationsNAttendanceModesKey(unitFiltered[0])
        }
      }
    }

    return ''
  }

  getLocationsNAttendanceModesKey = unit => {
    return (
      unit.unitAvailabilityLocationCode +
      '-' +
      unit.unitAvailabilityAttendanceModeCode
    )
  }

  getDefaultLocationsNAttendanceModes = (defaultAcademicYear, studyPeriod) => {
    let units = this.props.units.filter(
      unit => unit.unitAvailabilityYear === defaultAcademicYear
    )

    if (studyPeriod) {
      units = units.filter(
        unit => unit.unitAvailabilityStudyPeriodCode === studyPeriod
      )
    }

    return uniqBy(units, function(unit) {
      return (
        unit.unitAvailabilityLocationCode +
        '-' +
        unit.unitAvailabilityAttendanceModeCode
      )
    })
  }

  getLocationsNAttendanceModes = year => {
    if (
      this.state.modalLocationNAttendanceModes &&
      this.state.modalLocationNAttendanceModes.length > 0
    ) {
      return this.state.modalLocationNAttendanceModes
    } else {
      return this.getDefaultLocationsNAttendanceModes(year)
    }
  }

  convertLocationsNAttendanceModeSelection = selectedValue => {
    const locationsNAttendanceModesByYear = this.getLocationsNAttendanceModes(
      this.state.modalAcademicYear
    ).filter(
      unit => this.getLocationsNAttendanceModesKey(unit) === selectedValue
    )
    if (locationsNAttendanceModesByYear.length >= 1) {
      return locationsNAttendanceModesByYear[0]
    }
    return ''
  }

  submitDropDateConfirmation = () => {
    this.setState({
      dropDateSubmissionConfirmation: true,
      showDropDatePassedConfirmationModal: false
    })
    this.handleSubmitUnit()
  }

  handleSubmitUnit = () => {
    const unit = this.props.units.find(unit => {
      return (
        unit.unitCode === this.props.unitCode &&
        unit.unitAvailabilityYear === this.state.modalAcademicYear &&
        unit.unitAvailabilityLocationCode === this.state.modelLocation &&
        unit.unitAvailabilityAttendanceModeCode ===
          this.state.modelAttendanceMode &&
        unit.unitAvailabilityStudyPeriodCode === this.state.modelStudyPeriod &&
        unit.unitAvailabilityKeyNumber === this.state.modelKeyNumber
      )
    })

    if (unit) {
      if (
        unitDropDatePassed(unit) &&
        !this.state.dropDateSubmissionConfirmation &&
        this.props.title !== 'Edit unit'
      ) {
        this.setState({ showDropDatePassedConfirmationModal: true })
      } else if (
        this.props.canAddBeyondFirstYear === 'true' &&
        unit.unitCreditPoints > this.props.advanceStandingCreditRemaining
      ) {
        this.setState({
          submitting: false
        })
        this.props.handleError(
          'You are unable to enrol into Beyond First Year units in this block.' +
            ' For more information about your study options, please contact VUHQ.'
        )
      } else {
        this.props.handleSubmitUnit(unit)
        this.setState({ dropDateSubmissionConfirmation: false })
      }
    } else {
      this.props.dispatchError(
        'Unable to find a unit with the selected parameters.'
      )
    }
  }

  getYearOptions = () => {
    return uniqBy(this.props.units, 'unitAvailabilityYear').map(unit => ({
      value: unit.unitAvailabilityYear,
      label: unit.unitAvailabilityYear
    }))
  }

  getUnitByCalTypeWithDropDate = calType => {
    return this.props.units.find(
      unit =>
        unit.unitAvailabilityStudyPeriodCode === calType &&
        unit.unitCode === this.props.unitCode &&
        unit.unitAvailabilityYear === this.state.modalAcademicYear &&
        unit.unitAvailabilityLocationCode ===
          this.state.modalLocationNAttendanceMode
    )
  }

  getUnitByCalType = calType => {
    return this.props.units.find(
      unit => unit.unitAvailabilityStudyPeriodCode === calType
    )
  }

  getCampusOptions = () => {
    return this.getLocationsNAttendanceModes(this.state.modalAcademicYear).map(
      unit => ({
        value: this.getLocationsNAttendanceModesKey(unit),
        label:
          unit.unitAvailabilityLocationDescription +
          '-' +
          getAttendanceModeDescription(this.state.attendanceModeList,unit.unitAvailabilityAttendanceModeCode),
        disabled: this.isCampusDisabled(
          unit.unitAvailabilityLocationCode,
          unit.unitAvailabilityAttendanceModeCode
        )
      })
    )
  }

  isCampusDisabled = (location, attendanceMode) => {
    return this.props.units
      .filter(
        unit => unit.unitAvailabilityYear === this.state.modalAcademicYear
      )
      .filter(unit => unit.unitAvailabilityLocationCode === location)
      .filter(
        unit => unit.unitAvailabilityAttendanceModeCode === attendanceMode
      )
      .every(
        unit =>
          unit.unitAvailabilityMaxQuota &&
          (unit.unitAvailabilityQuotaRemaining !== null &&
            unit.unitAvailabilityQuotaRemaining <= 0)
      )
  }

  isCalendarTypeOpenDisabled = (
    unitCode,
    year,
    location,
    calType,
    quotaRemaining,
    unitAvailabilityMaxQuota
  ) => {
    return (
      unitAvailabilityMaxQuota > 0 &&
      (quotaRemaining !== null && quotaRemaining <= 0)
    )
  }

  convertStudyPeriodNKeyNumberSelection = (selectedValue) => {
    const unitFiltered = this.props.units
      .filter(
        unit => unit.unitAvailabilityYear === this.state.modalAcademicYear
      )
      .filter(
        unit => unit.unitAvailabilityLocationCode === this.state.modelLocation
      )
      .filter(
        unit =>
          unit.unitAvailabilityAttendanceModeCode ===
          this.state.modelAttendanceMode
      )
      .filter(
        unit => {
          return unit.unitAvailabilityKeyNumber +'-' +unit.unitAvailabilityStudyPeriodCode === selectedValue
        }
      )

    if (unitFiltered.length === 1) {
      return unitFiltered[0]
    }
    return null
  }

  getCalendarTypeOptions = () => {
    const calendarTypeOpens = this.props.units
      .filter(unit => unit.unitAvailabilityYear === this.state.modalAcademicYear)
      .filter(unit => unit.unitAvailabilityLocationCode === this.state.modelLocation)
      .filter(unit => unit.unitAvailabilityAttendanceModeCode === this.state.modelAttendanceMode)
      .map(unit => ({
        value: unit.unitAvailabilityKeyNumber + '-' + unit.unitAvailabilityStudyPeriodCode,
        label: (
          <span>
            {unit.unitAvailabilityStudyPeriodDescription}{' '}
            {unit.unitAvailabilityMaxQuota !== 0 && unit.unitAvailabilityQuotaRemaining !== null ? (
              <span className="quota-indicator">
                ({unit.unitAvailabilityQuotaRemaining} spots remaining)
              </span>
            ) : null}
          </span>
        ),
        disabled: this.isCalendarTypeOpenDisabled(
          this.props.unitCode,
          unit.unitAvailabilityYear,
          unit.unitAvailabilityLocationCode,
          unit.unitAvailabilityStudyPeriodCode,
          unit.unitAvailabilityQuotaRemaining,
          unit.unitAvailabilityMaxQuota
        ),
        unitData: unit
      }));
      
    return sortBy(calendarTypeOpens, 'value');
  }

  /**
   * Check whether a unit has pre-requisites.
   *
   * @return {Boolean}
   */
  hasRequisiteUnits = () => {
    return this.props.units.some(unit => unit.unitRequisiteFlag)
  }

  handleDropDateCloseModal = () => {
    this.setState({
      showDropDatePassedConfirmationModal: false,
      submitting: false
    })
  }

  getRequisiteMessage = () => {
    if (this.hasRequisiteUnits()) {
      return (
        <p>
          <b>Note:</b> This unit has requisites associated -{' '}
          <a
            target="_blank"
            href={`https://www.vu.edu.au/units/${this.props.unitCode}`}
          >
            Find out more
          </a>
        </p>
      )
    }
    return null
  }

  renderRequisiteWarnings = () => {
    if (this.hasRequisiteUnits()) {
      return (
        <div className="sidenote sidenote--warning sidenote-sm">
          <div className="sidenote__content">
            <div>{this.getRequisiteMessage()}</div>
          </div>
        </div>
      )
    }
    return null
  }

  getSelectedUnit = () => {
    const unit = this.props.units.find(unit => {
      return (
        unit.unitCode === this.props.unitCode &&
        unit.unitAvailabilityYear === this.state.modalAcademicYear &&
        unit.unitAvailabilityLocationCode === this.state.modelLocation &&
        unit.unitAvailabilityAttendanceModeCode ===
          this.state.modelAttendanceMode &&
        unit.unitAvailabilityStudyPeriodCode === this.state.modelStudyPeriod &&
        unit.unitAvailabilityKeyNumber === this.state.modelKeyNumber
      )
    })
    return unit ? unit : null
  }

  renderDropDatePassedWarnings = () => {
    const unit = this.getSelectedUnit()
    if (
      unit !== null &&
      unitHasDropDate(unit) &&
      (unitDropDatePassed(unit) || unitDropDateNotPassed(unit))
    ) {
      return (
        <div className="sidenote sidenote--warning sidenote-sm">
          <div className="sidenote__content">
            <div>
              <p>{getDropDateUnitTextAddEdit(unit)}</p>
            </div>
          </div>
        </div>
      )
    }
  }

  renderDropDateConfirmationModal = () => {
    return (
      <CustomModal
        className={'drop-date-confirmation-modal'}
        isOpen={this.state.showDropDatePassedConfirmationModal}
        userCanClose={true}
        handleCloseModal={this.handleDropDateCloseModal}
        title="Online withdraw deadline has passed"
      >
        <div className="question-group">
          <div className="form-items-group">
            The unit you have selected has an early online withdraw deadline
            that has passed. If you proceed, you will be unable to withdraw from
            this unit without college approval.
          </div>
        </div>
        <div className="row">
          <div className="col-xs-6 col-md-6">
            <button
              className="btn btn-lg btn-primary"
              onClick={() => this.submitDropDateConfirmation()}
            >
              OK
            </button>
          </div>
          <div className="col-xs-6 col-md-6">
            <button
              className="btn btn-lg btn-primary"
              onClick={this.handleDropDateCloseModal}
            >
              CANCEL
            </button>
          </div>
        </div>
      </CustomModal>
    )
  }

  render() {
    if (!this.props.isOpen) {
      return null
    }

    return (
      <CustomModal
        className={'modal'}
        isOpen={this.props.isOpen}
        handleCloseModal={() => this.props.handleCloseModal()}
        title={this.props.title}
      >
        {this.props.loading ? (
          <div className="question-group">Loading...</div>
        ) : (
          <div className="question-group" style={{paddingBottom: 8}}>
             {this.renderRequisiteWarnings()}
            <FormControl variant='standard' fullWidth sx={{marginBottom: 2}}>
              <InputLabel>Year</InputLabel>
              <Select
                name="Year"
                options={this.getYearOptions()}
                onChange={event => {
                  let year = event.target.value
                  const availableLocations = this.getLocationsNAttendanceModes(
                    year
                  )

                  this.setState({
                    modalAcademicYear: year,
                    modalLocationNAttendanceMode:
                      availableLocations.length === 1
                        ? availableLocations[0].unitAvailabilityLocationCode
                        : '',
                    modalStudyPeriodNKeyNumber: ''
                  })
                }}
                value={this.state.modalAcademicYear}
              >
                { 
                  this.getYearOptions().map(option => (
                    <MenuItem key={option.value} value={option.value}>{option.label}</MenuItem>
                  ))
                }
              </Select>
            </FormControl>
             
            {this.state.modalAcademicYear === '' ? null : (
              <FormControl variant='standard' fullWidth sx={{marginBottom: 2}}>
                <InputLabel>Campus</InputLabel>
                <Select
                  name="Campus"
                  options={this.getCampusOptions()}
                  onChange={event => {
                    const unit = this.convertLocationsNAttendanceModeSelection(
                      event.target.value
                    )

                    let location = ''
                    let attendanceMode = ''
                    if (unit !== null) {
                      location = unit.unitAvailabilityLocationCode
                      attendanceMode = unit.unitAvailabilityAttendanceModeCode
                    }

                    const unitFiltered = this.props.units
                      .filter(
                        unit =>
                          unit.unitAvailabilityYear ===
                          this.state.modalAcademicYear
                      )
                      .filter(
                        unit => unit.unitAvailabilityLocationCode === location
                      )
                      .filter(
                        unit =>
                          unit.unitAvailabilityAttendanceModeCode ===
                          attendanceMode
                      )

                    this.setState({
                      modalLocationNAttendanceMode: event.target.value,
                      modelLocation: location,
                      modelAttendanceMode: attendanceMode,
                      modalStudyPeriodNKeyNumber:
                        unitFiltered.length === 1
                          ? unitFiltered[0].unitAvailabilityKeyNumber +
                            '-' +
                            unitFiltered[0].unitAvailabilityStudyPeriodCode
                          : '',
                      modelStudyPeriod:
                        unitFiltered.length === 1
                          ? unitFiltered[0].unitAvailabilityStudyPeriodCode
                          : '',
                      modelKeyNumber:
                        unitFiltered.length === 1
                          ? unitFiltered[0].unitAvailabilityKeyNumber
                          : ''
                    })
                  }}
                  value={this.state.modalLocationNAttendanceMode}
                >
                  {
                    this.getCampusOptions().map(option => 
                      <MenuItem key={option.value} value={option.value}>{option.label}</MenuItem>
                    )
                  }
                </Select>
              </FormControl>
            )}
            {this.state.modalLocationNAttendanceMode === '' ? null : (
              // <FormControl variant='standard' fullWidth>
              //   <InputLabel>calendarType</InputLabel>
              //   <Select
              //     name="Calendar Type"
              //     options={this.getCalendarTypeOptions()}
              //     onChange={event => {
              //       const unit = this.convertStudyPeriodNKeyNumberSelection(
              //         event.target.value
              //       )

              //       this.setState({
              //         modalStudyPeriodNKeyNumber: event.target.value,
              //         modelStudyPeriod:
              //           unit !== null
              //             ? unit.unitAvailabilityStudyPeriodCode
              //             : '',
              //         modelKeyNumber:
              //           unit !== null ? unit.unitAvailabilityKeyNumber : ''
              //       })
              //     }}
              //     value={this.state.modalStudyPeriodNKeyNumber}
              //   >
              //     {
              //       this.getCalendarTypeOptions().map(option =>
              //         <MenuItem key={option.value} value={option.value}>{option.label}</MenuItem>
              //       )
              //     }
              //   </Select>
              // </FormControl>
              <FormControl variant='standard' fullWidth sx={{marginBottom: 2}}>
                <InputLabel>Calendar Type</InputLabel>
                <Select
                  name="Calendar Type"
                  value={this.state.modalStudyPeriodNKeyNumber}
                  onChange={event => {
                    const selectedValue = event.target.value;
                    const selectedOption = this.getCalendarTypeOptions().find(option => option.value === selectedValue);
                    
                    this.setState({
                      modalStudyPeriodNKeyNumber: selectedValue,
                      modelStudyPeriod: selectedOption?.unitData?.unitAvailabilityStudyPeriodCode || '',
                      modelKeyNumber: selectedOption?.unitData?.unitAvailabilityKeyNumber || ''
                    });
                  }}
                >
                  {this.getCalendarTypeOptions().map(option => (
                    <MenuItem 
                      key={option.value} 
                      value={option.value} 
                      disabled={option.disabled}
                    >
                      {option.label}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            )}
          </div>
        )}
        {this.renderDropDatePassedWarnings()}
        <button
          className="btn btn-primary btn-lg"
          disabled={
            !this.state.modalStudyPeriodNKeyNumber || this.props.submitting
          }
          onClick={this.handleSubmitUnit}
        >
          {this.props.submitting
            ? this.props.buttonLoadText
            : this.props.buttonText}
        </button>
        {this.props.title !== 'Edit unit' &&
          this.renderDropDateConfirmationModal()}
      </CustomModal>
    )
  }
}

export default UnitModal
